// Services
import api from '../../services/api';
import helpers from '../../services/helpers';

const state = {
  status: '',
  token: localStorage.getItem('token') || '',
  user: {}
};

const getters = {
  isLoggedIn: (state) => !!state.token,
  authStatus: (state) => state.status,
};

const actions = {
  login({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('authRequest');
      api({ url: '/api/auth-token/', data: user, method: 'POST' })
        .then((resp) => {
          const { token, user } = resp.data;
          // Save token
          localStorage.setItem('token', token);
          // Get shopper config
          helpers.getShopperConfig();
          commit('authSuccess', token, user);
          resolve(resp);
        })
        .catch((err) => {
          commit('authError');
          localStorage.removeItem('token');
          reject(err);
        });
    });
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      try {
        // Inform store
        commit('logout');
        // Remove token
        localStorage.removeItem('token');
        resolve();
      } catch (err) {
        commit('logoutError');
        reject(err);
      }
    });
  }
};

const mutations = {
  authRequest(state) {
    state.status = 'loading';
  },
  authSuccess(state, token, user) {
    state.status = 'success';
    state.token = token;
    state.user = user;
  },
  authError(state) {
    state.status = 'error';
  },
  logoutError(state) {
    state.status = 'error';
  },
  logout(state) {
    state.status = '';
    state.token = '';
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};